import React, { useContext, useEffect, useState } from "react";
import Input from "components/Elements/Input";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import styled from "styled-components";

import { flattenObject, unflattenObject } from "../../utils/utils";

import { AppContext } from "../../contexts/AppContext";
import { updateSupportingContentItem } from "../../services/lessons";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const Lesson = () => {
  const { activeUser } = useSelector((state) => state.users);
  const [saving, setSaving] = useState(false);
  const { setLessonID, lesson } = useContext(AppContext);
  const { lessonID, lessonNumber } = useParams();
  const [lessonContent, setLessonContent] = useState(null);
  const [lessonPractice, setLessonPractice] = useState(null);
  const [lessonQuiz, setLessonQuiz] = useState(null);
  const [lessonPrompts, setLessonPrompts] = useState(null);
  const [lessonOutline, setLessonOutline] = useState(null);
  const [lessonScreens, setLessonScreens] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      document.querySelectorAll("textarea").forEach((item) => {
        item.style.height = `${item.scrollHeight}px`;
      });
    }, 2000);
  }, []);
  useEffect(() => {
    console.log("!!! LESSON ID: ", lessonID);
    if (lessonID) {
      setLessonID(lessonID);
    }
    // eslint-disable-next-line
  }, [lessonID]);

  useEffect(() => {
    if (!lesson) return;

    console.log("!!! LESSON: ", lesson);

    const content = lesson.lesson;
    const outline = lesson.outline;
    const practice = lesson["lesson-practice"];
    const prompts = lesson["lesson-prompts"];
    const quiz = lesson["lesson-quiz"];
    const screens = lesson["lesson-screens"];
    console.log("!!! SCREENS: ", screens);

    if (outline) {
      console.log("!!! OUTLINE: ", outline);
      const outlineData = {
        public_id: outline.public_id,
        title: outline.name,
        data: outline.data,
      };
      console.log("!!! OUTLINE: ", outlineData);
      setLessonOutline(outlineData);
    }

    if (content) {
      let data = content.data;
      try {
        data = JSON.parse(
          // eslint-disable-next-line
          data.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").replace(",}", "}")
        );
      } catch (ex) {}

      const contentData = {
        public_id: content.public_id,
        title: content.name,
        data: flattenObject(data),
      };
      console.log("!!! CONTENT: ", contentData);
      setLessonContent(contentData);
    }

    if (screens) {
      let data = screens.data;
      try {
        data = JSON.parse(
          // eslint-disable-next-line
          data.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").replace(",}", "}")
        );
      } catch (ex) {}

      setLessonScreens({
        public_id: screens.public_id,
        title: screens.name,
        data: flattenObject(data, "", {}, [
          "embedding",
          "id",
          "media_id",
          "type",
          "anonymized",
          "similarity",
        ]),
      });
    }

    if (prompts) {
      let data = prompts.data;
      try {
        data = JSON.parse(
          // eslint-disable-next-line
          data.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").replace(",}", "}")
        );
      } catch (ex) {}

      const promptsData = {
        public_id: prompts.public_id,
        title: prompts.name,
        data: flattenObject(data),
      };
      console.log("!!! PROMPTS: ", promptsData);
      setLessonPrompts(promptsData);
    }

    if (quiz) {
      let data = quiz.data;
      try {
        data = JSON.parse(
          // eslint-disable-next-line
          data.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").replace(",}", "}")
        );
      } catch (ex) {}

      const quizData = {
        public_id: quiz.public_id,
        title: quiz.name,
        data: flattenObject(data),
      };
      console.log("!!! QUIZ: ", quizData);
      setLessonQuiz(quizData);
    }

    if (practice) {
      let data = practice.data;
      try {
        data = JSON.parse(
          // eslint-disable-next-line
          data.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").replace(",}", "}")
        );
      } catch (ex) {}

      const practiceData = {
        public_id: practice.public_id,
        title: practice.name,
        data: flattenObject(data),
      };
      console.log("!!! PRACTICE: ", practiceData);
      setLessonPractice(practiceData);
    }
  }, [lesson]);

  const saveLesson = async () => {
    setSaving(true);

    await updateSupportingContentItem(lessonContent.public_id, {
      data: JSON.stringify(unflattenObject(lessonContent.data)),
    });
    await updateSupportingContentItem(lessonPractice.public_id, {
      data: JSON.stringify(unflattenObject(lessonPractice.data)),
    });
    await updateSupportingContentItem(lessonOutline.public_id, {
      data: lessonOutline.data,
    });
    await updateSupportingContentItem(lessonPrompts.public_id, {
      data: JSON.stringify(unflattenObject(lessonPrompts.data)),
    });
    await updateSupportingContentItem(lessonQuiz.public_id, {
      data: JSON.stringify(unflattenObject(lessonQuiz.data)),
    });

    setSaving(false);
  };

  const renderField = (key, obj, updateFunc = () => {}) => {
    obj = { ...obj };
    const data = key === "data" ? obj.data : obj.data[key];
    return (
      <div key={key}>
        <label>{key.replace(/:/g, " > ")}</label>
        <Input
          type="textarea"
          label={key}
          placeholder={key}
          name="data"
          value={data}
          onChange={(e) => {
            const height = e.target.scrollHeight;
            e.target.style.height = `${height}px`;

            if (key === "data") {
              obj.data = e.target.value;
            } else {
              obj.data[key] = e.target.value;
            }
            updateFunc(obj);
          }}
          className="textarearesize"
        />
      </div>
    );
  };

  const renderForm = (title, obj, updateFunc) => {
    if (!obj) return <></>;

    return (
      <>
        <h3 className="font-bold text-lg text-blueGray-700">
          {lessonNumber}. {title}
        </h3>
        <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
          <label>Public ID</label>
          <Input
            label="Public ID"
            placeholder="Public ID"
            name="public_id"
            value={obj.public_id}
            onChange={() => {}}
            disabled
          />
          <label>Title</label>
          <Input
            label="Title"
            placeholder="Title"
            name="title"
            value={obj.title}
            onChange={(e) => {}}
          />
          {typeof obj.data === "string" || typeof obj.data === "number"
            ? renderField("data", obj, updateFunc)
            : Object.keys(obj.data).map((key, index) =>
                renderField(key, obj, updateFunc)
              )}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="relative p-6 flex-auto ">
              <div>
                <a
                  href={
                    lesson
                      ? `/lessons/${lesson.lesson.supporting_content_id}`
                      : ``
                  }
                >
                  <i className="fa fa-arrow-left" /> Back to Lessons
                </a>{" "}
              </div>
              <h3 style={{ fontSize: "22px", fontWeight: 600 }}>
                Edit {lesson ? lesson.lesson.name : "Lesson"}
              </h3>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <div className="flex flex-wrap flex-col">
                  {renderForm("Outline", lessonOutline, setLessonOutline)}
                  {renderForm("Content", lessonContent, setLessonContent)}
                  {renderForm("Screens", lessonScreens, setLessonScreens)}
                  {renderForm("Prompts", lessonPrompts, setLessonPrompts)}
                  {renderForm("Practice", lessonPractice, setLessonPractice)}
                  {renderForm("Quiz", lessonQuiz, setLessonQuiz)}
                </div>
              </div>
              {activeUser && activeUser.user_type === "admin" && (
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={saveLesson}
                  >
                    {saving ? (
                      <>
                        <i className="fas fa-circle-notch fa-spin"></i>{" "}
                        Saving...
                      </>
                    ) : (
                      <>Save Changes</>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Lesson;
